import { DEFAULT_ENVIRONMENT_IMAGE_URL } from 'trace-viewer/scene';
import type { EnvironmentPreset } from 'trace-viewer/build';
import { resolveEnvironment as resolveEngineEnvironment } from 'trace-viewer/build';
export { resolveKeyLight } from 'trace-viewer/build';
export type { EnvironmentPreset } from 'trace-viewer/build';

/** Optional environment choices belong to the editor host, not the engine. */
export const ENVIRONMENT_PRESETS = {
    none: '', neutral: DEFAULT_ENVIRONMENT_IMAGE_URL,
    studio: 'https://playground.babylonjs.com/textures/Studio_Softbox_2Umbrellas_cube_specular.env',
    country: 'https://playground.babylonjs.com/textures/country.env',
    night: 'https://playground.babylonjs.com/textures/night.env',
    parking: 'https://playground.babylonjs.com/textures/parking.env',
    forest: 'https://playground.babylonjs.com/textures/forest.env',
} as const satisfies Record<EnvironmentPreset, string>;

export function resolveEnvironment(
    preset: Parameters<typeof resolveEngineEnvironment>[0],
    options?: Parameters<typeof resolveEngineEnvironment>[1],
) {
    return resolveEngineEnvironment(preset, options, ENVIRONMENT_PRESETS);
}
